function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import { LocaleProvider, ThemeProvider } from 'oskari-ui/util';
import { TimeSeriesRangeControl } from './TimeSeriesRange/TimeSeriesRangeControl';
import { TimeSeriesRangeControlHandler } from './TimeSeriesRange/TimeSeriesRangeControlHandler';
var BasicMapModulePlugin = Oskari.clazz.get('Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin');
/**
 * @class Oskari.mapframework.bundle.timeseries.TimeSeriesRangeControlPlugin
 */
var TimeSeriesRangeControlPlugin = /*#__PURE__*/function (_BasicMapModulePlugin) {
  function TimeSeriesRangeControlPlugin(delegate, conf) {
    var _this;
    _classCallCheck(this, TimeSeriesRangeControlPlugin);
    _this = _callSuper(this, TimeSeriesRangeControlPlugin, [conf]);
    _this._clazz = 'Oskari.mapframework.bundle.timeseries.TimeSeriesRangeControlPlugin';
    _this._name = 'TimeSeriesRangeControlPlugin';
    _this._defaultLocation = 'top left';
    _this._log = Oskari.log(_this._name);
    _this._toolOpen = false;
    _this._element = null;
    _this._isMobile = Oskari.util.isMobile();
    _this._sandbox = Oskari.getSandbox();
    _this.mapModule = _this._sandbox.findRegisteredModuleInstance('MainMapModule');
    _this._delegate = delegate;
    _this.stateHandler = new TimeSeriesRangeControlHandler(delegate, function () {
      return _this.updateUI();
    });
    _this._updateCurrentViewportBbox();
    return _this;
  }
  _inherits(TimeSeriesRangeControlPlugin, _BasicMapModulePlugin);
  return _createClass(TimeSeriesRangeControlPlugin, [{
    key: "hasUI",
    value: function hasUI() {
      return true;
    }
  }, {
    key: "isShouldStopForPublisher",
    value: function isShouldStopForPublisher() {
      // prevent publisher to stop this plugin and start it again when leaving the publisher
      return false;
    }
  }, {
    key: "getControlState",
    value: function getControlState() {
      var _this$stateHandler$ge = this.stateHandler.getState(),
        value = _this$stateHandler$ge.value;
      var time;
      if (Array.isArray(value)) {
        time = value.map(function (item) {
          return item.toString();
        });
      } else {
        time = value.toString();
      }
      return {
        time: time
      };
    }
  }, {
    key: "setControlState",
    value: function setControlState(state) {
      var time = state.time;
      if (!time) {
        // don't set initial value if state doesn't have time value
        return;
      }
      var mode;
      var value;
      if (Array.isArray(time)) {
        mode = 'range';
        value = [parseInt(time[0], 10), parseInt(time[1], 10)];
      } else {
        mode = 'year';
        value = parseInt(time);
      }
      this.stateHandler.setInitialValue(value, mode);
    }
  }, {
    key: "getName",
    value: function getName() {
      return this._name;
    }
  }, {
    key: "updateUI",
    value: function updateUI() {
      var mountElement = this.getReactMountElement();
      if (!mountElement) {
        return;
      }
      ReactDOM.render(/*#__PURE__*/React.createElement(LocaleProvider, {
        value: {
          bundleKey: 'timeseries'
        }
      }, /*#__PURE__*/React.createElement(ThemeProvider, {
        value: this.mapModule.getMapTheme()
      }, /*#__PURE__*/React.createElement(TimeSeriesRangeControl, _extends({}, this.stateHandler.getState(), {
        controller: this.stateHandler.getController(),
        isMobile: this._isMobile
      })))), mountElement);
    }
  }, {
    key: "getReactMountElement",
    value: function getReactMountElement() {
      var element = this.getElement();
      return element && element.get(0);
    }
  }, {
    key: "redrawUI",
    value: function redrawUI(mapInMobileMode, forced) {
      _superPropGet(TimeSeriesRangeControlPlugin, "redrawUI", this, 3)([mapInMobileMode, forced]);
      this.updateUI();
      this.makeDraggable();
    }
  }, {
    key: "makeDraggable",
    value: function makeDraggable() {
      var element = this.getElement();
      if (!element) {
        return;
      }
      element.draggable({
        scroll: false,
        // the drag handle class is defined in react component
        handle: '.timeseries-range-drag-handle'
      });
    }

    /**
     * Compares delegate to controls own delegate to see if it's being controlled by this plugin
     * @param {Oskari.mapframework.bundle.timeseries.TimeseriesDelegate} delegate for comparison
     * @returns {Boolean}
     */
  }, {
    key: "isControlling",
    value: function isControlling(delegate) {
      if (!delegate) {
        return false;
      }
      if (!this._delegate) {
        return false;
      }
      if (this._delegate._clazz !== delegate._clazz) {
        return false;
      }
      // we only have the WMSAnimator at this time but check that delegate is it so we can expect to find getLayer()
      if (this._delegate._clazz !== 'Oskari.mapframework.bundle.timeseries.WMSAnimator') {
        return false;
      }
      // here we can be sure that delegate and this._delegate are both WMSAnimator
      var myLayer = this._delegate.getLayer();
      var theirLayer = delegate.getLayer();
      if (!myLayer || !theirLayer) {
        return false;
      }
      return myLayer.getId() === theirLayer.getId();
    }
  }, {
    key: "_createControlElement",
    value: function _createControlElement() {
      return jQuery('<div class="mapplugin timeseriesrangecontrolplugin"></div>');
    }
  }, {
    key: "_createEventHandlers",
    value: function _createEventHandlers() {
      var _this2 = this;
      return {
        AfterMapMoveEvent: function AfterMapMoveEvent() {
          return _this2._updateCurrentViewportBbox();
        },
        MapSizeChangedEvent: function MapSizeChangedEvent() {
          var isMobileCurrent = Oskari.util.isMobile();
          var isMobilePrevious = _this2._getMobileMode();
          if (isMobilePrevious !== isMobileCurrent) {
            _this2._setMobileMode(isMobileCurrent);
            _this2.redrawUI(isMobileCurrent, true);
          }
        }
      };
    }
  }, {
    key: "_getMobileMode",
    value: function _getMobileMode() {
      return this._isMobile;
    }
  }, {
    key: "_setMobileMode",
    value: function _setMobileMode(isMobile) {
      this._isMobile = isMobile;
    }
  }, {
    key: "_updateCurrentViewportBbox",
    value: function _updateCurrentViewportBbox() {
      var sandbox = this.getSandbox();
      var currentBbox = sandbox.getMap().getBbox();
      var zoomLevel = sandbox.getMap().getZoom();
      this.stateHandler.setCurrentViewportBbox(currentBbox, zoomLevel);
    }
  }]);
}(BasicMapModulePlugin);
Oskari.clazz.defineES('Oskari.mapframework.bundle.timeseries.TimeSeriesRangeControlPlugin', TimeSeriesRangeControlPlugin, {
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});